import React from "react";
import { Button, Col, Modal, Row } from "antd";
import { useSelector } from "react-redux";
import { defaultPaperOpenAddSelector } from "store/bailiff/(default)/paper/default_paper.selector";
import { useKycAdd } from "hook/base/kyc/useKyc";
import KycDocument from "./component/kyc_document";
import KycAction from "./component/kyc_action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogKycAction = () => {
  // -------------------------- VAR -----------------------------
  const { handleClosePreview } = useKycAdd();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(defaultPaperOpenAddSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      title="Xác nhận giấy tờ hợp lệ"
      centered
      footer={null}
      onCancel={handleClosePreview}
      open={open}
    >
      <Row gutter={[0, 20]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <KycDocument />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <KycAction />
        </Col>
      </Row>
    </Modal>
  );
};
export default DialogKycAction;
